
import React, { Suspense, lazy } from "react";
import { Skeleton } from "@/components/ui/skeleton";

interface LazyTabContentProps {
  activeTab: string;
  tabValue: string;
  children: React.ReactNode;
}

const LazyTabContent = React.memo(({ activeTab, tabValue, children }: LazyTabContentProps) => {
  // Only render content when tab is active
  if (activeTab !== tabValue) {
    return null;
  }

  return (
    <Suspense fallback={
      <div className="space-y-4 p-6">
        <Skeleton className="h-8 w-64" />
        <Skeleton className="h-64 w-full" />
        <Skeleton className="h-32 w-full" />
      </div>
    }>
      {children}
    </Suspense>
  );
});

LazyTabContent.displayName = "LazyTabContent";

export default LazyTabContent;
